import overview from './modules/overview'

const RootRoutes = () => [
  ...overview()
]

export default RootRoutes
